import styled from "styled-components";
import {
  Space,
  Button as AntButton,
  Form as AntForm,
  Input as AntInput,
} from "antd";

export const RootContainer = styled.div`
  padding-top: 16px;
  .ant-form {
    margin-top: 22px;

    @media screen and (max-width: 375px) {
      min-height: calc(100vh - 398px);
    }

    @media screen and (max-width: 325px) {
      min-height: calc(100vh - 389px);
    }

    .ant-form-item-label {
      text-align: left;
      padding-left: 20px;
    }
    .ant-form-item-label label {
      color: #004f9c !important;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  .ant-input {
    padding-left: 20px;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: #000000;
    background: #D9D9D9;
    border: none !important;
    border-radius: 16px !important;

    ::placeholder {
      color: #000000 !important;
      opacity: 0.5 !important;
    }
  }

  .float-label label {
    color: #c21c05;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const InfoBox = styled(Space).attrs({
  direction: "horizontal",
})`
  width: calc(100% - 60px);
  align-items: center;
  justify-content: flex-start;
  margin: 0px 16px 0px 16px;
  padding: 16px 13px 9px 13px;
  border-radius: 16px;
  background: #DEEDFF;
`;

export const Image = styled.img.attrs({
  alt: "icon",
})`
  width: 68px;
  border-radius: 8px;
`;

export const Text = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #000000;

  @media screen and (max-width: 345px) {
    font-size: 13px;
  }

  @media screen and (max-width: 320px) {
    font-size: 12px;
  }
`;

export const BoldText = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #71207c;
`;

export const GroupContainer = styled.div`
  background: #fff;
  padding: 16px;
  border-radius: 16px 16px 0px 0px;

  @media screen and (max-width: 325px) {
    .ant-col {
      padding-left: 3px !important;
      padding-right: 3px !important;
    }
  }
`;

export const Item = styled.div`
  padding: 12px;
  border-radius: 8px;
  border: none;
  background: ${(props) => (props.selected === "true" ? "linear-gradient(90deg, #0060BE 0%, #04AEED 100%)" : "#DEEDFF")};
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 20px;

  ${Text} {
    flex: 1;
    color: ${(props) => (props.selected === "true" ? "#FFF" : "#000")};
    text-align: left;
  }

  @media screen and (max-width: 375px) {
    padding: 8px;

    ${Text} {
      font-size: 12px;
    }
  }

  @media screen and (max-width: 325px) {
    padding: 8px;

    ${Text} {
      font-size: 10px;
    }
  }
`;

export const HelperText = styled.div`
  padding-top: 6px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #004F9C;
  width: 100%;
  text-align: left;
  padding-left: 20px;

  @media screen and (max-width: 345px) {
    font-size: 11px;
  }

  @media screen and (max-width: 320px) {
    font-size: 10px;
  }
`;

export const ButtonWrapper = styled.div`
  text-align: center;
  margin: auto 16px;

  .ant-btn {
    height: 52px;
    margin-top: 24px;
  }
`;

export const Box = styled(Space).attrs({
  size: "middle",
})`
  margin-right: -36px;
  align-items: center;

  .anticon {
    font-size: 20px;
    cursor: pointer;
  }
`;

export const FormContainer = styled.div`
  background: #fff;
  padding: 16px;
`;

export const ContinueButton = styled(AntButton)`
  color: ${(props) =>
    props.amount ? `#6D1304 !important` : "#FFF !important"};
  border-radius: 16px !important;
`;

export const Form = styled(AntForm)`
  width: 100%;
  margin-top: 0px !important;

  .ant-form-item {
    margin-bottom: 32px;
  }

  .ant-form-item-required {
    padding-left: 10px;
    color: #817774 !important;
  }

  input {
    border: 1px solid #dfdfdf;
    border-radius: 12px;
    background: #f2f1f0;
    color: #342309 !important;
    :hover,
    :focus {
      border: 1px solid #dfdfdf;
    }
    ::placeholder {
      color: #342309;
    }
  }

  input[type="text"],
  input[type="number"] {
    height: 52px;
  }

  input[type="password"] {
    height: 40px;
  }
`;

export const Input = styled(AntInput)`
  -moz-appearance: textfield;
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
`;

export const CustomAmountContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #D9D9D9;
  border-radius: 26px;
  margin: 16px 16px 0;
  padding: 8px;
`;

export const CustomAmountTitle = styled.div`
  color: #000;
  font-size: 14px;
  font-weight: 400;
  padding: 0px 4px;
`;